import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  disableClicks: {
    pointerEvents: "none",
    opacity: 0.5
  },
  modes: {
    display: "none",
    visibility: "hidden"
  },
  item: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%"
  },
  card: {
    height: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    padding: "10px",
    boxSizing: "border-box",
    minWidth: "22rem",
    borderRadius: "10px",
    border: "solid 1px #ebebeb"
  },
  itemOn: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%",
    borderRight: "1px lightgray solid"
  },
  button: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    marginBottom: "5px",
    padding: "8px"
  },
  powerButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f6f6f7",
    // marginBottom: "5px",
    padding: "0",
    borderRadius: "50%",
    // marginLeft: "0.5rem",
    width: "2.8rem",
    height: "2.8rem"
  },
  powerText: {
    fontWeight: 100,
    fontSize: "1rem"
  },
  powerIcon: {
    height: "2.9rem",
    width: "2.9rem",
    margin: "0.15rem"
  },
  icon: {
    fontSize: "2.3125rem"
  },

  controlContainer: {
    backgroundColor: "#f6f6f6",
    width: "200px",
    borderRadius: "10px",
    height: "100%"
  },

  powerOn: {
    background: "purple",
    width: "2.8rem",
    height: "2.8rem",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.05)",
    backgroundColor: "#4b1c46",
    borderRadius: "50%",
    color: "white"
  },
  powerOff: {
    background: "white",
    color: "gray",
    width: "2.8rem",
    height: "2.8rem",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.05)",
    backgroundColor: "#ffffff",
    borderRadius: "50%"
  },
  powerButtonSVG: {
    position: "relative",
    fontSize: "1.3rem"
  },
  InputNumber: {
    backgroundColor: "inherit",
    fontSize: "2rem",
    alignItems: "space-between",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },

  Number: {
    color: "transparent",
    textShadow: "0 0 0 #4b1c46",
    width: "100%",
    maxWidth: "100%",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f6f6f7",
    border: "none",
    fontSize: "2.34rem",
    outline: "none",
    letterSpacing: "0.078125rem",
    textAlign: "right",
    fontFamily: "Roboto"
  },
  chevron: {
    fontSize: "0.8125rem"
  },

  temperatureScale: {
    fontFamily: "Roboto",
    fontSize: "1.125rem",
    letterSpacing: "0.03625rem",
    color: "#4b1c46",
    alignSelf: "flex-end",
    marginBottom: 10
  },

  controlWrapper: {
    display: "flex",
    justifyContent: "center",
    transform: "scale(1.3)",
    cursor: "pointer",
    background: "none",
    color: "#7f7182",
    margin: "0px 35px",
    borderRadius: "4px",
    "&:hover": {
      transform: "scale(1.301)"
    },
    "&:active": {
      color: "#4b1c46"
    }
  },
  tempWrapper: {},
  disableClick: { pointerEvents: "none", opacity: 0.4 },
  sensorSliderContainer: {
    maxWidth: "320px",
    maxHeight: "152px",
    zIndex: 1,
    position: "absolute",
    marginTop: "-17px"
  },
  sensorValues: {
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "25px",
    letterSpacing: "normal",
    color: "#4b1c46"
  },
  sensorValue: {
     fontFamily: "Roboto",
     fontSize: 15,
     fontWeight: "normal",
     fontStretch: "normal",
     fontStyle: "normal",
     lineHeight: "normal",
     letterSpacing: "normal",
     color: "#4b1c46"
  },
  sensorValuesContainer: {
    position: "absolute",
    top: "103px",
    left: "18px",
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    width: "164px",
    pointerEvents: "none"
  },
  valueControl: {
    position: "absolute",
    top: "45px",
    width: "200px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none"
  },
  measurementUnit: {
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: " #4b1c46",
    height: 80,
    lineHeight: "80px"
},
  centeredBox: {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}
});

export default useStyles;
